import * as React from 'react'
import FormWrapper from '../form/FormWrapper'
import useFormState from '../form/hooks/useFormState'
import InputField from '../form/InputField'
import { StaticImage } from 'gatsby-plugin-image'
import CategoryImage from '../CategoryImage'
import isEmail from './validators/isEmail'
import isPhoneNumber from './validators/isPhone'
import {
  IconAsscherDiamond,
  IconEmeraldDiamond,
  IconEternityBand,
  IconOvalDiamond,
  IconRoundDiamond,
} from '../IconsDiamondShapes'
import InputSelect from './InputSelect'
import { Link } from 'gatsby'

const CustomEternityBandForm = () => {
  const [form, setForm, updateForm] = useFormState({
    name: '',
    phone: '',
    email: '',
    diamond_shape: 'ROUND',
    metal: '18k White Gold',
    budget: '',
    ring_size: '',
    total_weight: '',
    message: '',
    consent: true,
  })

  const diamondShape = form.diamond_shape
  const metal = form.metal
  const handleShapeSelect = (e, shape) => {
    e.preventDefault()
    setForm(f => ({ ...f, diamond_shape: shape }))
  }

  // Function to determine the image path
  const getImage = () => {
    const color = metal === '18k Yellow Gold' ? 'YELLOW' : 'WHITE'
    const option = `${diamondShape}-${color}`
    switch (option) {
      case 'ROUND-YELLOW':
        return (
          <StaticImage
            loading="eager"
            src="../../images/round-yellow.jpg"
            alt={`${diamondShape} ${color} Gold`}
          />
        )
      case 'OVAL-YELLOW':
        return (
          <StaticImage
            loading="eager"
            src="../../images/oval-yellow.jpg"
            alt={`${diamondShape} ${color} Gold`}
          />
        )
      case 'ASSCHER-YELLOW':
        return (
          <StaticImage
            loading="eager"
            src="../../images/asscher-yellow.jpg"
            alt={`${diamondShape} ${color} Gold`}
          />
        )
      case 'EMERALD-YELLOW':
        return (
          <StaticImage
            loading="eager"
            src="../../images/emerald-yellow.jpg"
            alt={`${diamondShape} ${color} Gold`}
          />
        )

      case 'OVAL-WHITE':
        return (
          <StaticImage
            loading="eager"
            src="../../images/oval-white.jpg"
            alt={`${diamondShape} ${color} Gold`}
          />
        )
      case 'ASSCHER-WHITE':
        return (
          <StaticImage
            loading="eager"
            src="../../images/asscher-white.jpg"
            alt={`${diamondShape} ${color} Gold`}
          />
        )
      case 'EMERALD-WHITE':
        return (
          <StaticImage
            loading="eager"
            src="../../images/emerald-white.jpg"
            alt={`${diamondShape} ${color} Gold`}
          />
        )

      //case 'ROUND-WHITE':
      default:
        return (
          <StaticImage
            loading="eager"
            src="../../images/round-white.jpg"
            alt={`${diamondShape} ${color} Gold`}
          />
        )
    }
  }

  const SelectedImage = getImage()
  const onChangeHandler = e => {
    setForm(f => ({ ...f, [e.target.name]: e.target.checked }))
  }
  return (
    <div id="eternity-bands" className="max-w-[1366px] w-full mx-auto py-5">
      <h2 className="w-full px-5 text-center uppercase text-lg lg:text-3xl font-bold text-red-600 py-2 leading-snug">
        Build your own Diamond <nobr>Eternity Band</nobr>
      </h2>
      <p className="text-center px-5 pb-3">
        Let us create <b>YOUR MASTERPIECE!</b>
      </p>
      <div className="flex w-full flex-col justify-center ">
        <FormWrapper
          className={'bg-white pb-4 form-checkbox overflow-y-auto flex flex-col '}
          name={'Custom Diamond Eternity Band'}
          action={'/thank-you-diamond-eternity-band/'}
          form={form}
          minimumTimeout={1000}
        >
          <div className="w-full flex flex-col lg:flex-row gap-4">
            <div className="mx-auto w-11/12 lg:w-full flex flex-col">
              <div className="w-full border-2 my-4 lg:my-0 max-w-[500px] mx-auto order-last lg:order-first">
                <div className="aspect-square w-full h-full mx-auto">{SelectedImage}</div>
              </div>
              <h4 className="border-t pt-2 lg:border-t-0 text-center font-bold pb-3 text-gray-600">
                SELECT YOUR DIAMOND SHAPE
              </h4>
              <div className="w-full max-w-[500px] mx-auto grid grid-cols-4 justify-center text-gray-400 duration-200">
                {/* Buttons for diamond shape */}
                {['ROUND', 'EMERALD', 'OVAL', 'ASSCHER'].map(shape => (
                  <button
                    key={shape}
                    className={`w-full flex flex-col justify-between items-center duration-200 ${
                      diamondShape === shape ? 'text-red-600 ' : 'hover:text-black'
                    }`}
                    onClick={e => handleShapeSelect(e, shape)}
                  >
                    {shape === 'ROUND' && (
                      <IconRoundDiamond className={'size-16 sm:size-20 mb-2 p-1'} />
                    )}
                    {shape === 'EMERALD' && (
                      <IconEmeraldDiamond className={'size-16 sm:size-20 mb-2'} />
                    )}
                    {shape === 'OVAL' && <IconOvalDiamond className={'size-16 sm:size-20 mb-2'} />}
                    {shape === 'ASSCHER' && (
                      <IconAsscherDiamond className={'size-16 sm:size-20 mb-2 p-1'} />
                    )}
                    {shape}
                  </button>
                ))}
              </div>

              {/* Metal Selection */}
              <div className="w-full max-w-[500px] mx-auto flex flex-row h-12 justify-between items-center gap-2">
                <InputSelect
                  errorMessage=""
                  name={'metal'}
                  label={'Metal'}
                  form={form}
                  onChange={updateForm}
                  required={true}
                  options={[
                    { value: '18k White Gold', label: '18k White Gold' },
                    { value: '18k Yellow Gold', label: '18k Yellow Gold' },
                    { value: 'Platinum', label: 'Platinum' },
                  ]}
                  className=" h-full cursor-pointer appearance-none w-3/4"
                />

                {metal ? (
                  <div
                    className={
                      ' w-1/4 translate-y-2 mx-auto h-12 border-2 bg-gradient-to-tr ' +
                      (metal === '18k Yellow Gold'
                        ? 'from-amber-200 via-accentMd to-amber-100'
                        : 'from-slate-100 via-slate-300 to-blue-100')
                    }
                  />
                ) : (
                  <div className="w-1/4 h-12" />
                )}
              </div>
            </div>

            <div className="w-11/12 mx-auto flex justify-center lg:justify-start ">
              <div className="lg:pr-4 max-w-[500px]">
                <h4 className=" text-center font-bold pb-3 text-gray-600 tracking-tight ">
                  ENTER YOUR BUDGET OR DIAMOND WEIGHT
                </h4>
                <p className="text-slate-600 text-sm">
                  * Including your budget or total diamond weight (total carats) will help us find
                  the right size and quality diamond for you. If you are unsure, please provide a
                  range.
                </p>
                <div className="grid md:grid-cols-2 gap-2 pb-2">
                  <InputField
                    errorMessage=""
                    name={'budget'}
                    label={'Budget'}
                    form={form}
                    onChange={updateForm}
                    required={form.total_weight === ''}
                    inputClassName="text-2xl font-black text-red-600"
                  />
                  <InputField
                    errorMessage=""
                    name={'total_weight'}
                    label={'Total Weight (cts)'}
                    form={form}
                    onChange={updateForm}
                    required={form.budget === ''}
                    inputClassName="text-2xl font-black text-red-600"
                  />
                  <InputField
                    errorMessage=""
                    name={'ring_size'}
                    label={'Ring Size'}
                    form={form}
                    onChange={updateForm}
                    inputClassName="text-2xl font-black text-red-600"
                  />
                  <a
                    href="https://www.grayandsons.com/pdfs/gns_ring_measurement.pdf"
                    target="_blank"
                    rel="noreferrer"
                    className="block rounded-md bg-green-600 text-center font-bold text-white hover:bg-green-800 py-2 md:m-3 translate-y-2 duration-200"
                  >
                    MEASUREMENT GUIDE
                  </a>
                </div>
                <InputField
                  errorMessage=""
                  name={'name'}
                  label={'Name'}
                  form={form}
                  onChange={updateForm}
                  required={true}
                />
                <InputField
                  errorMessage=""
                  name={'phone'}
                  label={'Telephone'}
                  form={form}
                  validator={isPhoneNumber}
                  onChange={updateForm}
                  required={true}
                />
                <InputField
                  errorMessage=""
                  name={'email'}
                  label={'E-Mail'}
                  form={form}
                  validator={isEmail}
                  onChange={updateForm}
                  required={true}
                />
                <InputField
                  errorMessage=""
                  name={'message'}
                  type="textarea"
                  rows={4}
                  label={'Message'}
                  form={form}
                  onChange={updateForm}
                />
                <label className="text-xs text-gray-500 flex flex-row gap-3 items-start my-2">
                  <input
                    type="checkbox"
                    name="consent"
                    checked={form['consent']}
                    onChange={onChangeHandler}
                  />
                  I agree to receive updates and follow-up messages about my inquiries via text and
                  email.
                </label>
                <button className="mt-2 rounded-md bg-red-600 px-8 py-2 font-bold text-white hover:bg-red-800">
                  REQUEST QUOTE
                </button>
              </div>
            </div>
          </div>
        </FormWrapper>
      </div>
    </div>
  )
}

export default CustomEternityBandForm
